import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import { getMainCategoryList, getSubCategoryList } from '@/api/modules/product-management/category-management';

import search from '@/libs/search';

export const saveStandardCard = data => {
    return axios.request({
        url: 'api/productManagement/standardCard/saveStandardCard',
        data: data,
        method: 'post'
    });
};

export const getStandardCardList = data => {
    return axios.request({
        url: 'api/productManagement/standardCard/getStandardCardList',
        data: data,
        method: 'post'
    });
};

export const getStandardCardDetail = standardCardUuid => {
    return axios.request({
        url: 'api/productManagement/standardCard/getStandardCardDetail',
        data: { standardCardUuid },
        method: 'post'
    });
};

export const pageInit4StandardCardEdit = () => {
    const searchCondition = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getMainCategoryList(searchCondition),
        getSubCategoryList(searchCondition)
    ]).then(axiosRequest.spread(function (main, sub) {
        if (main.code === 0 && sub.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    mainCategories: main.data.records,
                    subCategories: sub.data.records
                }
            };
        }
    }));
};

export const updateStandardCardApprove = data => {
    return axios.request({
        url: 'api/productManagement/standardCard/updateStandardCardApprove',
        data: data,
        method: 'post'
    });
};
